import { Component } from '@angular/core';

@Component({
  selector: 'app-load-analysis',
  templateUrl: './load-analysis.component.html',
})
export class LoadAnalysisComponent {}
